import { lazy, Suspense } from 'react';
import { LazyAssetsFallback, type LazyAssetProps } from '@frontend/internal-assets';

const LazyDigitalFormsSampleTwoColumnSvg = lazy(() => import('./svg-components/digital-formssample-two-column-svg'));

const DigitalFormsSampleTwoColumnSvg = ({ assetsFallbackProps = {}, customFallback, ...rest }: LazyAssetProps) => (
  <Suspense fallback={customFallback || <LazyAssetsFallback {...assetsFallbackProps} />}>
    <LazyDigitalFormsSampleTwoColumnSvg {...rest} />
  </Suspense>
);

export default DigitalFormsSampleTwoColumnSvg;
